import { actionTypes } from 'app/types/action_types';

const initialState = {
  assetType: null,
  family: 'creative',
  mediaType: null,
  assetfiletype: null,
  isHomepage: false,
};

const initialize = (state, payload) => ({
  ...state,
  assetType: payload.assetType || state.assetType,
  family: payload.family || state.family,
  mediaType: payload.mediaType,
  assetfiletype: payload.assetfiletype || state.assetfiletype,
  isHomepage: payload.isHomepage,
});

// eslint-disable-next-line default-param-last
const headerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return initialize(state, action.payload);
    default:
      return state;
  }
};

export default headerReducer;
